import { useNavigate, useParams } from "react-router-dom";
import BoxGames from "../../components/homeUI/BoxGames";
import { motion } from "framer-motion";
import { Arrow } from "../../components/svg/Wallet/Wallet";

const bgs = [
  {
    bg: "linear-gradient(215.13deg, #FF0084 -3.92%, #AF0014 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #00B3FF -3.92%, #0040AF 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #00FBFF -3.92%, #75AF00 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #FFBB2A -3.92%, #E28605 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #00FBFF -3.92%, #75AF00 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #00FBFF -3.92%, #1A8169 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #E100FF -3.92%, #3700AF 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #FFBB2A -3.92%, #E28605 95.77%)",
  },
];

const games = [
  { title: "Word Trivia Deluxe" },
  { title: "Math Whiz" },
  { title: "History Buff" },
  { title: "Science Explorer" },
  { title: "Geography Guru" },
  { title: "Literature Lover" },
  { title: "Art Aficionado" },
  { title: "Music Maestro" },
];

function GamingCategory() {
  const navigate = useNavigate();
  const { id } = useParams();

  const getRandomBg = () => {
    const randomIndex = Math.floor(Math.random() * bgs.length);
    return bgs[randomIndex].bg;
  };

  return (
    <div className=" ">
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
        transition={{
          type: "tween",
          duration: 0.9,
          ease: [0.4, 0.0, 0.2, 1],
        }}
        className="w-full relative flex flex-col flex-grow"
      >
        <div>
          <div
            style={{
              background: getRandomBg(),
            }}
            className="p-2.5 pt-10"
          >
            <div className="relative flex items-center justify-center mb-2">
              <Arrow
                onClick={() => navigate(-1)}
                fill="#ffffff"
                stroke="#fff"
                className="text-lg absolute left-0 cursor-pointer"
              />
              <h4 className="font-medium text-lg text-white text-center flex-grow capitalize">
                {id.replaceAll("-", " ")}
              </h4>
            </div>
            <img
              className="max-w-[175px] object-contain grid place-self-end"
              src="/image/arena_image.png"
              alt="banner"
              loading="lazy"
            />
            <p className="text-white font-semibold text-xl capitalize">
              {id.replaceAll("-", " ")}
            </p>
          </div>
          <div className=" grid grid-cols-12 gap-5 pb-5 px-4 pt-7 ">
            {games.map((x, i) => {
              return (
                <div key={i} className="col-span-6">
                  <BoxGames x={x} fromCategory />
                </div>
              );
            })}
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default GamingCategory;
